import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import pluralize from 'pluralize'
import getMenuData from 'services/menu'
import { history } from 'index'
import * as firebase from 'services/firebase'
import * as jwt from 'services/jwt'
import actions from './actions'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
  jwt: {
    login: jwt.login,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
}

export function* LOGIN({ payload }) {
  const { username, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(jwt.login, username, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* REGISTER({ payload }) {
  const { email, password, name } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[authProvider].register, email, password, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(jwt.currentAccount)
  if (response) {
    const { userId, email, firstName, lastName, avatar, country, role } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id: userId,
        name: `${firstName} ${lastName}`,
        countryName: (country && country.name) || '',
        email,
        avatar,
        role: role.name,
        authorized: true,
      },
    })
  }

  // Fetch dynamic region names
  const regionResponse = yield call(jwt.getRegions)
  let regionPayload = {}
  if (regionResponse) {
    const { adminLevelOne, adminLevelTwo, adminLevelThree } = regionResponse
    regionPayload = {
      adminLevelOne,
      adminLevelTwo,
      adminLevelThree,
      plural: {
        adminLevelOne: pluralize(adminLevelOne),
        adminLevelTwo: pluralize(adminLevelTwo),
        adminLevelThree: pluralize(adminLevelThree),
      },
    }
    yield put({
      type: 'region-names/SET_STATE',
      payload: regionPayload,
    })
  }

  // Load menu data
  const menuData = yield call(getMenuData, regionPayload)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })

  // End loading state
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(jwt.logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
